const detectOldIOS = () => {
  let isIOS13 = navigator.userAgent.match(/OS 13_\d/i);
  isIOS13 = Array.from(isIOS13 || []).length > 0;

  let isIOS14 = navigator.userAgent.match(/OS 14_\d/i);
  isIOS14 = Array.from(isIOS14 || []).length > 0;
  return isIOS13 || isIOS14;
};

export default detectOldIOS;
